export default __webpack_public_path__ + "static/media/logo-cmtech-login.f6ad8d29.png";